import Course from '../objects/Course';
import Selectvalues from '../objects/SelectValues';

export default class Category extends Selectvalues {
    private _id: number;
    private _name: string;
    private _is_course: boolean;
    private _courses: Array<Course>;

    constructor(categories:any) {
        super();

        this._id = categories.id;
        this._name = categories.category;
        this._is_course = categories.is_course;

        var courses_list:any;

        courses_list = () => {
            let courses:Array<Course> = [];
            // @ts-ignore
            categories.courses.map((v: any) => {
                courses.push(new Course(v));
            });

            // @ts-ignore
            return courses;
        }
        this._courses = courses_list();
    }

    get courses(): Array<Course> {
        return this._courses;
    }
    get is_course(): boolean {
        return this._is_course;
    }
    get name(): string {
        return this._name;
    }
    get id(): number {
        return this._id;
    }
}
